import React, { useEffect, useState } from "react";
import {
    Button,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Form,
    FormGroup,
    Label,
    Input,
} from "reactstrap";
import { useLoader } from "../../_helper/LoaderContext";
import { addPatient, updatePatient } from "../Patient/service/patient-service";
import { toast } from "react-toastify";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { stateMaster } from "../LabProfile/service/profile-service";
import S3ImageLoader from "../../S3ImageLoader";
import errorProfile from "../../assets/images/blank_profile.png";

export default function AddPatient({ toggleUploadModel, setUploadModelOpen, data, getList, getData, onPatientCreated }) {
    const [formData, setFormData] = useState({
        name: "",
        mobile: "",
        age: "",
        gender: "",
        email: "",
        address: "",
        state: "",
    });
    const { setLoading } = useLoader()
    const [errors, setErrors] = useState({});
    const [states, setStates] = useState([]);
    const [statesLoaded, setStatesLoaded] = useState(false);
    const [imageSource, setImageSource] = useState(null);
    const [imageSourceS3, setImageSourceS3] = useState(null);
    const [imageFile, setImageFile] = useState(null);

    const validate = () => {
        const newErrors = {};

        // Name validation — no numbers or special characters
        if (!formData.name.trim()) {
            newErrors.name = "Name is required";
        } else if (!/^[A-Za-z\s]+$/.test(formData.name)) {
            newErrors.name = "Only letters and spaces allowed";
        }

        // Mobile validation — only digits, must be 10 digits
        if (!formData.mobile.trim()) {
            newErrors.mobile = "Mobile number is required";
        }
        // if (!formData.state.trim()) {
        //     newErrors.state = "State is required";
        // }

        // Age validation
        if (!formData.age.trim()) {
            newErrors.age = "Age is required";
        } else
            if (isNaN(formData.age) || formData.age <= 0) {
                newErrors.age = "Enter valid age";
            }

        // Gender validation
        if (!formData.gender) {
            newErrors.gender = "Gender is required";
        }

        // Email validation
        if (!formData.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            newErrors.email = "Enter valid email";
        }

        // Address validation
        // if (!formData.address.trim()) {
        //     newErrors.address = "Address is required";
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const normalize = (v = "") => v.trim().toLowerCase();

    useEffect(() => {
        if (!data || states.length === 0) return;

        const matchedState = states.find(
            s => normalize(s.State) === normalize(data.state)
        );

        setFormData(prev => ({
            ...prev,
            state: matchedState ? matchedState.State : ""
        }));
    }, [data, states]);

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setFormData({
                name: data.name || "",
                mobile: data.contact ? String(data.contact) : "",
                age: data.age || "",
                gender: data.gender || "",
                email: data.email || "",
                address: data.address || "",
                state: data.state || "",
            });
            setImageSourceS3(data.profilePicture);
        } else {
            setFormData({
                name: "",
                mobile: "",
                age: "",
                gender: "",
                email: "",
                address: "",
                state: "",
            });
        }
    }, [data]);

    useEffect(() => {
        fetchStates()
    }, [])

    const fetchStates = async (state, district, city, pincode) => {
        setLoading(true)
        try {
            const res = await stateMaster({ country: "India" });
            if (res.data.success == true) {
                setStates(res.data.data);
                setStatesLoaded(true);
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleLogoChange = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const allowedTypes = [
            'image/jpeg', 'image/jpg', 'image/png',
            'image/tiff', 'image/bpg', 'image/bmp',
            'image/heic', 'image/heif'
        ];

        if (!allowedTypes.includes(file.type)) {
            toast.warning("Invalid image format");
            e.target.value = "";
            return;
        }

        const reader = new FileReader();
        reader.onloadend = () => {
            setImageSource(reader.result); // ✅ local preview
        };
        reader.readAsDataURL(file);

        setImageFile(file);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (data.name) {
            setLoading(true);
            try {
                const form_data = new FormData();
                form_data.append("fname", formData.name);
                // form_data.append("lname",data.);
                form_data.append("email", formData.email);
                form_data.append("contact", formData.mobile);
                form_data.append("age", formData.age);
                form_data.append("gender", formData.gender);
                form_data.append("address", formData.address);
                form_data.append("state", formData.state);
                form_data.append("isWalkIn", true);
                form_data.append("profilePicture", imageFile);
                const res = await updatePatient(data._id, form_data);
                if (res.data.success == true) {
                    toast.success(res.data.message);
                    setFormData({
                        name: "",
                        mobile: "",
                        age: "",
                        gender: "",
                        email: "",
                        address: "",
                    });
                    setErrors({});
                    setUploadModelOpen(false);
                    getList()
                }
            } catch (error) {
                console.log(error)
            } finally {
                setLoading(false)
            }
        } else {
            if (validate()) {
                setLoading(true);
                try {
                    const form_data = new FormData();
                    form_data.append("fname", formData.name);
                    // form_data.append("lname",data.);
                    form_data.append("email", formData.email);
                    form_data.append("contact", formData.mobile);
                    form_data.append("age", formData.age);
                    form_data.append("gender", formData.gender);
                    form_data.append("address", formData.address);
                    form_data.append("state", formData.state);
                    form_data.append("isWalkIn", false);
                    form_data.append("profilePicture", imageFile);
                    const res = await addPatient(form_data);
                    if (res.data.success === true) {
                        toast.success(res.data.message);
                        getList()
                        setFormData({
                            name: "",
                            mobile: "",
                            age: "",
                            gender: "",
                            email: "",
                            address: "",
                        });
                        setErrors({});
                        setUploadModelOpen(false);
                        onPatientCreated(res.data.data)
                        getList()
                        if (getData) {
                            getData()
                        }
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    setLoading(false)
                }
            }

        }
    };

    return (
        <>
            <ModalBody>
                <h3 className="mb-3">
                    {data.name ? "Edit Patient" : "Add Patient"} </h3>
                <Form>
                    {/* Name */}
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup className="mb-3">
                                <Label for="name">Name <span className="text-danger">*</span></Label>
                                <Input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Enter name"
                                    value={formData.name}
                                    onChange={handleChange}
                                    invalid={!!errors.name}
                                />
                                {errors.name && (
                                    <div className="invalid-feedback d-block">{errors.name}</div>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            {/* Mobile */}
                            <FormGroup className="mb-3">
                                <Label for="mobile">Mobile Number <span className="text-danger">*</span></Label>
                                <PhoneInput
                                    country={"in"}            // default India
                                    value={formData.mobile}
                                    onChange={(value) => setFormData(prev => ({ ...prev, mobile: value }))}
                                    inputProps={{
                                        name: "mobile",
                                        required: true,
                                        className: "form-control"
                                    }}
                                    enableSearch={true}
                                    searchPlaceholder="Search country"
                                />

                                {errors.mobile && (
                                    <div className="invalid-feedback d-block">{errors.mobile}</div>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            {/* Age */}
                            <FormGroup className="mb-3">
                                <Label for="age">Age <span className="text-danger">*</span></Label>
                                <Input
                                    type="number"
                                    id="age"
                                    name="age"
                                    placeholder="Enter age"
                                    value={formData.age}
                                    onChange={handleChange}
                                    invalid={!!errors.age}
                                />
                                {errors.age && (
                                    <div className="invalid-feedback d-block">{errors.age}</div>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            {/* Email */}
                            <FormGroup className="mb-3">
                                <Label for="email">Email <span className="text-danger">*</span></Label>
                                <Input
                                    type="email"
                                    id="email"
                                    name="email"
                                    placeholder="Enter email address"
                                    value={formData.email}
                                    onChange={handleChange}
                                    invalid={!!errors.email}
                                />
                                {errors.email && (
                                    <div className="invalid-feedback d-block">{errors.email}</div>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            {/* Gender */}
                            <FormGroup className="mb-3">
                                <Label>Gender <span className="text-danger">*</span></Label>
                                <div className="d-flex gap-3 mt-1">
                                    <div className="radio radio-primary">
                                        <Input
                                            id="customer-radio-gloabal"
                                            type="radio"
                                            name="gender"
                                            value="male"
                                            checked={formData.gender === "male"}
                                            onChange={handleChange}
                                        />
                                        <Label for="customer-radio-gloabal" className="mb-0 pe-2">
                                            Male
                                        </Label>
                                    </div>
                                    <div className="radio radio-primary">
                                        <Input
                                            id="customer-radio-female"
                                            type="radio"
                                            name="gender"
                                            value="female"
                                            checked={formData.gender === "female"}
                                            onChange={handleChange}
                                        />
                                        <Label for="customer-radio-female" className="mb-0 pe-2">
                                            Female
                                        </Label>
                                    </div>
                                </div>
                                {errors.gender && (
                                    <div className="invalid-feedback d-block">{errors.gender}</div>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup className="mb-3">
                                <Label for="state">State </Label>
                                {/* <Input
                                    type="state"
                                    id="state"
                                    name="state"
                                    placeholder="Enter state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    invalid={!!errors.state}
                                /> */}
                                <select
                                    className="form-select form-select-lg"
                                    value={formData.state}
                                    onChange={(e) =>
                                        setFormData(prev => ({ ...prev, state: e.target.value }))
                                    }
                                >
                                    <option value="">Select State</option>
                                    {states.map(s => (
                                        <option key={s._id} value={s.State}>
                                            {s.State}
                                        </option>
                                    ))}
                                </select>
                                {errors.state && (
                                    <div className="invalid-feedback d-block">{errors.state}</div>
                                )}
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            <FormGroup>
                                <Label for="logo-upload">Profile Image </Label>
                                <input
                                    id="logo-upload"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleLogoChange}
                                    className="form-control"
                                />
                            </FormGroup>
                        </div>
                        <div className="col-md-6">
                            {/* Profile Image Preview */}
                            <div className="col-md-2">
                                {imageSource ? (
                                    // ✅ Show newly selected image immediately
                                    <img
                                        src={imageSource}
                                        alt="Profile Preview"
                                        className="frame-box"
                                        style={{ height: '75px', width: '100%', objectFit: 'cover' }}
                                        onError={(e) => (e.target.src = errorProfile)}
                                    />
                                ) : (
                                    // ✅ Show image from API / S3
                                    <S3ImageLoader
                                        className="frame-box"
                                        fileName={imageSourceS3}
                                        style={{ height: '75px', width: '100%', objectFit: 'cover' }}
                                        alt="Profile"
                                        fallbackSrc={errorProfile}
                                    />
                                )}
                            </div>
                        </div>
                    </div>


                    {/* Address */}
                    <FormGroup className="mb-3">
                        <Label for="address">Address</Label>
                        <Input
                            type="textarea"
                            id="address"
                            name="address"
                            placeholder="Enter address"
                            value={formData.address}
                            onChange={handleChange}
                            invalid={!!errors.address}
                        />
                        {errors.address && (
                            <div className="invalid-feedback d-block">{errors.address}</div>
                        )}
                    </FormGroup>
                </Form>
            </ModalBody>

            <ModalFooter>
                <Button color="primary" onClick={handleSubmit}>
                    {data.name ? "Update" : "Submit"}
                </Button>
                <Button color="secondary" onClick={toggleUploadModel}>
                    Cancel
                </Button>
            </ModalFooter>
        </>
    );
}
